exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tag-c[data-v-3e7f4d3e] {\n  overflow: hidden;\n}\n.tag-create[data-v-3e7f4d3e] {\n  border: 1px solid;\n  width: 100%;\n  padding: 8px;\n}\n.tag-create .title[data-v-3e7f4d3e] {\n    font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e7f4d3e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components2/Common/Screen/organisms/ChatBotTags.vue
// module id = ql2M
// module chunks = 0